/**
 * MM ESSENTIELS - Collection Page JavaScript
 * Handles: filter form submit, sidebar toggle, sort
 */

(function () {
  const filterToggle = document.querySelector('[data-mm-filter-toggle]');
  const filterSidebar = document.querySelector('[data-mm-filters]');
  const filterClose = document.querySelector('[data-mm-filter-close]');
  const filterForm = document.querySelector('[data-mm-filter-form]');
  const sortSelect = document.querySelector('[data-mm-sort]');

  if (!filterToggle || !filterSidebar) return;

  /* Auto-open sidebar if there are active filters in the URL */
  const hasActiveFilters = window.location.search.includes('filter.');
  if (hasActiveFilters) {
    filterSidebar.classList.add('is-open');
  }

  /* Toggle filter sidebar */
  filterToggle.addEventListener('click', () => {
    filterSidebar.classList.toggle('is-open');
    const isOpen = filterSidebar.classList.contains('is-open');
    document.body.style.overflow = isOpen && window.innerWidth < 750 ? 'hidden' : '';
  });

  /* Close filter sidebar (mobile) */
  if (filterClose) {
    filterClose.addEventListener('click', () => {
      filterSidebar.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  /* Auto-submit filter form when any checkbox changes */
  if (filterForm) {
    filterForm.addEventListener('change', () => {
      filterForm.submit();
    });
  }

  /* Sort select → update hidden input and submit form, or navigate directly */
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* Close sidebar on resize to desktop */
  window.addEventListener('resize', () => {
    if (window.innerWidth >= 750 && filterSidebar.classList.contains('is-open')) {
      document.body.style.overflow = '';
    }
  });
})();
